const fillServerErrors = require('../../../../common/components/servererrorfiller');
const { LoginResult } = require('../constant');

module.exports = function ($q, loginService, breakpointsService, $state, $window, moveFocus, formValidationService, googleCaptchaService) {
    return {
        restrict: 'E',
        template: require('./persistent-login-template.html').trim(),
        scope: {},
        link(scope) {

            // Move focus to reset password input when view has loaded
            moveFocus('#PersistentloginFormPassword');

            // we use the login prompt from the service in the template
            scope.loginService = loginService;
            scope.loading = false;
            scope.showReCaptchaErrorMessage = false;
            scope.reCaptchaError = null;
            scope.currentUserDetails = loginService.currentUserService.get();

            const validatePassword = function () {
                if (scope.PersistentloginFormPassword === undefined || scope.PersistentloginFormPassword.trim() === '') {
                    scope.persistentLoginForm.PersistentloginFormPassword.$setValidity('required', false);
                    scope.persistentLoginForm.PersistentloginFormPassword.$setTouched();
                    return false;
                }
                return true;
            };
            const validateLoginForm = function () {

                return validatePassword();
            };

            const setServerErrorValidity = function (isValid) {
                scope.persistentLoginForm.PersistentloginFormPassword.$setValidity('loginError', isValid);

                if (!isValid) {
                    formValidationService.focusSummary = true;
                }
            };

            scope.login = function (email, password) {

                fillServerErrors.clearForm(scope.persistentLoginForm, scope);
                setServerErrorValidity(true);
                scope.showReCaptchaErrorMessage = false;

                if (!scope.persistentLoginForm.$valid || !validateLoginForm()) {
                    // don't submit to server if client side is not valid
                    return $q.reject();
                }
                scope.loading = true;

                return googleCaptchaService
                    .execute(googleCaptchaService.ReCaptchaActions.Login)
                    .then((token) => {
                        const reCaptchaConfig = {
                            token,
                            action: googleCaptchaService.ReCaptchaActions.Login,
                            version: 'v3'
                        };

                        if ($state.params.intendedRoute
                            && $state.params.intendedRoute.to
                            && $state.params.intendedRoute.to !== '') {
                            loginService.setRedirectTo($state.params.intendedRoute.to, $state.params.intendedRoute.params);
                        } else {
                            loginService.setRedirectTo($state.previous.route.name, $state.previous.routeParams);
                        }

                        return loginService.login(email, password, reCaptchaConfig)
                            .then(function (response) {
                                if (response.LoginResult === LoginResult.SUCCESS) {
                                    if (response.ShouldUpdatePassword) {
                                        $state.go('shop.secureaccount.form');

                                        return response;
                                    }
                                    scope.loading = false;
                                    loginService.redirectAfterLogin();
                                } else if (response.LoginResult === LoginResult.REQUIRE_EMAIL_MFA) {
                                    $state.go('shop.authentication.verifyEmail', { email, password, emailMasked: response.MaskedEmail });
                                } else if (response.LoginResult === LoginResult.REQUIRE_PHONE_CAPTURE) {
                                    $state.go('shop.authentication.mobileNumberCapture', { email, password });
                                } else if (response.LoginResult === LoginResult.REQUIRE_SMS_MFA) {
                                    $state.go('shop.authentication.verifyMobile', { email, password, phoneMasked: response.MaskedPhone });
                                } else if (response.LoginResult === LoginResult.TOO_MANY_MFA_ATTEMPTS) {
                                    $state.go('shop.authentication.error', { error: 'TooManyCodeGenerationAttempts' });
                                } else {
                                    scope.AuthenticationErrorMessage = loginService.appendAttemptsRemaining(response);
                                    setServerErrorValidity(false);
                                    scope.loading = false;
                                }
                                return response;
                            })
                            .catch(function (response) {
                                scope.loading = false;
                                fillServerErrors.fillForm(scope.persistentLoginForm, response.data.ResponseStatus.Errors, scope);
                                setServerErrorValidity(false);
                            });
                    })
                    .catch((error) => {
                        scope.loading = false;
                        scope.reCaptchaError = error;
                        scope.showReCaptchaErrorMessage = true;
                    });
            };

            scope.logInAsAnotherUser = function () {
                loginService.loginInAsNewUser();
            };
        }
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/login/persistent-login/persistent-login-directive.js
 **/